'use client';

import { Overlay } from '@react-aria/overlays';
import * as React from 'react';

const PORTAL_ROOT_ID = 'twp-portal-root';

/**
 * Returns the shared overlay root used by all global portaled UI.
 * The node is created lazily on the client and scoped with `twp`
 * so transcluded Tailwind styles still apply outside the React subtree.
 */
function getOrCreateTwpPortalRoot(): HTMLElement | null {
    if (typeof document === 'undefined') {
        return null;
    }

    let root = document.getElementById(PORTAL_ROOT_ID) as HTMLDivElement | null;

    if (!root) {
        root = document.createElement('div');
        root.id = PORTAL_ROOT_ID;
        root.className = 'twp';
        document.body.appendChild(root);
    }

    return root;
}

export interface OverlayPortalProps {
    children: React.ReactNode;
}

/**
 * Portals content into the shared overlay root.
 * This gives all overlays the same DOM host across Astro islands and Next apps.
 */
function Portal({ children }: OverlayPortalProps) {
    const [container] = React.useState<HTMLElement | null>(getOrCreateTwpPortalRoot);

    if (!container) {
        return null;
    }

    return <Overlay portalContainer={container}>{children}</Overlay>;
}

export { Portal, getOrCreateTwpPortalRoot };
